function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Checkbox } from '../../Checkbox';

var CheckboxFieldComponent = function CheckboxFieldComponent(props) {
  var label = props.label,
      _props$labelPlacement = props.labelPlacement,
      labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement,
      disabled = props.disabled,
      classes = props.classes,
      className = props.className,
      others = _objectWithoutProperties(props, ["label", "labelPlacement", "disabled", "classes", "className"]);

  var checkbox =
  /*#__PURE__*/
  React.createElement(Checkbox, others);
  return (
    /*#__PURE__*/
    React.createElement(FormControlLabel, {
      disabled: disabled,
      control: checkbox,
      label: label,
      labelPlacement: labelPlacement,
      classes: classes,
      className: className
    })
  );
};

export var CheckboxField = CheckboxFieldComponent;